import React, { useEffect } from "react";
import { Select, Form, Modal, App } from "antd";
import { useDownloadThirdPartyBillingBatchBySelectMutation } from '../../../features/api/apiSlice';
const { Option } = Select;
function DownloadModal({ open, setOpen, data }) {
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [downloadBillingBatch, {
            isSuccess: downloadBillingBatchSuccess,
            isLoading: downloadBillingBatchLoading,
            isError: downloadBillingBatchError,
            error: downloadBillingBatchErrorInfo,
        }] = useDownloadThirdPartyBillingBatchBySelectMutation();

    useEffect(() => {
        if (downloadBillingBatchSuccess) {
            notification.success({
                message: '下载成功',
                description: '下载成功, 请在后台任务管理页面查看文件',
            });
            form.resetFields();
            setOpen(false);
        }
        if (downloadBillingBatchError) {
            notification.error({
                message: '下载失败',
                description: downloadBillingBatchErrorInfo?.data?.error || "未知原因,下载失败",
            });
        }
    }, [downloadBillingBatchSuccess, downloadBillingBatchError])
    const okButtonHandler = () => {
        form.validateFields()
            .then(values => {
                const request = {
                    ...values,
                    ids: data
                }
                downloadBillingBatch(request);
            })
            .catch(info => {
                console.log('Validate Failed:', info);
            });
    }

    return (
        <Modal
            title="下载数据"
            open={open}
            onCancel={() => setOpen(false)}
            onOk={okButtonHandler}
            confirmLoading={downloadBillingBatchLoading}
            >
            <Form
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 14 }}
                >
                <Form.Item
                    name="beneficiary_name"
                    label="Beneficiary Name"
                    rules={[{ required: true, message: '请输入批次ID' }]}
                >
                    <Select>
                        <Option value="0">Awesung Limited</Option>
                        <Option value="1">广州辕蓬物流有限公司</Option>
                    </Select>
                </Form.Item>
            </Form>

        </Modal>
    )
}

export default DownloadModal;